module.exports = __webpack_public_path__ + "img/10.00f4f9a5.jpg";